import type {ProposalSelection} from '@artemis-group/aiw-contracts';

/** LM remains the supplier input; the proposal's quantity and rate use purchased m². */
export function proposalPriceBasis(line:{unit:string;quantity:number},selection?:ProposalSelection,carpet=false){
 if(line.unit!=='LM'||!selection)return {quantity:line.quantity,unit:line.unit,width:1};
 const width=selection.carpetRollWidthM;
 if(!width)return carpet||/carpet/i.test(selection.group)?null:{quantity:line.quantity,unit:'LM',width:1};
 return {quantity:Math.round(line.quantity*width*100)/100,unit:'m²',width};
}
